import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';

const accionesEmpresas = {
	state: {
		datosEmpresa: {},
		procesos: [],
		propuesasPracticas: [],
		practicasAsignadas: [],
		NumTipoProcesos: [],
		faltaDatosAlaEmpresa: null,
		faltaDatosAlContacto: null,
		practicasGestionadas: '',
		menuEducacion: null,
		solicitudesEducacion: [],
		centrosTrabajoRegistroBeforeSend: [],
		faltaConvenioFirmado: null,
		clickedPopupFaltaConvenio: false,
		tutoresPracticas: [],
		contactosResponsablesPracticas: [],
		contactosFirmanteAnexo: [],
		contactosFirmanteConvenio: [],
		loadingProcesos: false
	},
	getters: {
		getProcesos: state => (state.procesos.length != 0) ? state.procesos : '0',
		getPropuestas: state => (state.propuesasPracticas.length != 0) ? state.propuesasPracticas : '0',
		getPracticasAsignadas: state => 
			(state.practicasAsignadas && state.practicasAsignadas.length !== 0) 
				? state.practicasAsignadas 
				: [],
		getNumProcesos: state => state.NumTipoProcesos,
		getProcesosEmpleo: state => state.procesos.filter(p => p.idPerfil == 1),
		getProcesosPracticas: state => state.procesos.filter(p => p.idPerfil == 2),
		getDatosEmpresa: state => state.datosEmpresa,
		getCentrosTrabajoSaved: state => state.centrosTrabajoRegistroBeforeSend,
		getTutoresPracticas: state => state.tutoresPracticas,
		getContactosResponsablesPracticas: state => state.contactosResponsablesPracticas,
		getLoadingProcesos: state => state.loadingProcesos,
		getterCentroSaved: (state) => (index) => {
			let entry = null
			if (state.centrosTrabajoRegistroBeforeSend) {
				entry = state.centrosTrabajoRegistroBeforeSend[index]
			}
			return entry;
		},

		getEstados: state => {
			let estados = new Object();

			state.procesos.forEach(p => {
				if (!!!estados[p.idEstado]) {
					estados[p.idEstado] = p.Estado
				}
			})

			return estados;
		},
		getEstadosPropuestas: state => {
			let estados = new Object();
			state.propuesasPracticas.forEach(p => {
				if (!!!estados[p.idEstado]) {
					estados[p.idEstado] = p.estado
				}
			})

			return estados;
		},
		getFaltanDatosAlaEmpresa: state => state.faltaDatosAlaEmpresa,
		getFaltanDatosAlContacto: state => state.faltaDatosAlContacto,
		getPracticasGestionadas: state => state.practicasGestionadas,
		getMenuEducacion: state => state.menuEducacion,
		getsolicitudesEducacion: state => state.solicitudesEducacion,
		getFirmaConvenio: state => state.faltaConvenioFirmado,
		getcentrosTrabajoEmpresa: state => state.datosEmpresa.centrosTrabajo,
		getContactosFirmanteAnexo: state => state.contactosFirmanteAnexo,
		getContactosFirmanteConvenio: state => state.contactosFirmanteConvenio
	},
	actions: {
		updateFaltaConvenioFirmado: function ({ state }) {
			state.faltaConvenioFirmado = window.localStorage.getItem("faltaConvenioFirmado")
		},
		requestProcesos: function ({ commit, dispatch, state, getters }) {
			return new Promise((resolve, reject) => {
				axios.get('api/Empresa/dameProcesosEmpleoYpracticas').then(response => {
					if (response.data.status == 0) {
						state.faltaConvenioFirmado = window.localStorage.getItem("faltaConvenioFirmado")
						commit('setProcesos', response.data.datos);
						resolve(true);
						if (state.faltaConvenioFirmado == 'true' && state.clickedPopupFaltaConvenio == false) {
							commit('setErrorCustomMensaje', getters.getBrand.empresaSinConvenio);
							state.clickedPopupFaltaConvenio = true
						}
					} else {
						commit('setCompleteError', response);
						resolve(false);
					}
				}).catch(function (error) {
					commit('setError', 500);
				});

			});

		},
		requestPropuestas: function ({ commit, dispatch, state, getters }) {
			if (state.propuesasPracticas.length > 0) {
				return true
			}
			return new Promise((resolve, reject) => {
				axios.get('api/Empresa/dameSolicitudesPracticas ').then(response => {
					if (response.data.status == 0) {
						state.propuesasPracticas = response.data.datos
						console.log(state)
						resolve(true);

					} else {
						commit('setCompleteError', response);
						resolve(false);
					}
				}).catch(function (error) {
					commit('setError', 500);
				});

			});

		},
		requestPracticasAsignadas: function ({ commit, dispatch, state, getters }) {
			if (state.practicasAsignadas && state.practicasAsignadas.length > 0) {
				return true
			}
			return new Promise((resolve, reject) => {
				axios.get('api/Empresa/damePracticasIncluyeDocumentacion ').then(response => {
					if (response.data.status == 0) {
						state.practicasAsignadas = response.data.datos
						console.log(state)
						resolve(true);

					} else {
						commit('setCompleteError', response);
						resolve(false);
					}
				}).catch(function (error) {
					commit('setError', 500);
				});

			});

		},


		requestNumProcesos: function ({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				commit('loadingProcesos')
				axios.get('api/Empresa/dameNumProcesos').then(response => {
					if (response.data.status == 0) {
						commit('setNumProcesos', response.data.datos);
						resolve(true);
						commit('endLoadProcesos')
					} else {
						commit('setCompleteError', response);
						resolve(false);
					}
				}).catch(function (error) {
					commit('setError', 500);
				});
			});
		},
		requestDatosEmpresa: function ({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get('/api/Empresa/dameDatosEmpresa').then(response => {
					if (response.data.status == 0) {
						commit('setDatosEmpresa', response.data.datos);
						resolve(response.data.datos);
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestDatosFirmanteEmpresa: function ({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get('/api/Empresa/dameDatosFirmanteEmpresa').then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		changeDatosFirmanteEmpresa: function ({ commit, dispatch }, data) {

			return new Promise((resolve, reject) => {

				axios.post('/api/Empresa/editaDatosFirmanteEmpresa', data).then(response => {
					if (response.data.status == 0) {
						resolve(true);
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});

		},
		recuerdoPass: function ({ commit, dispatch }, nick) {

			let data = { 'nick': nick };

			return new Promise((resolve, reject) => {

				axios.post('/api/Empresa/recuerdoPassword', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 505);
						resolve(true);
					} else {
						resolve(false);
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});

		},
		sendPasswordEmpresa: function ({ commit, dispatch }, data) {

			return new Promise((resolve, reject) => {

				axios.post('/api/Empresa/restablecerPassword', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 508);
						resolve(true);
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});

		},
		sendNewPassword: function ({ commit, dispatch }, data) {

			console.log(data);

			return new Promise((resolve, reject) => {

				axios.post('/api/Empresa/establecerPassword', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 514);
						resolve(true);
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});

		},
		changePassword: function ({ commit, dispatch }, data) {

			return new Promise((resolve, reject) => {

				axios.post('/api/Empresa/editaUsuario', data).then(response => {
					if (response.data.status == 0) {
						commit('setError', 508);
						resolve(true);
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});

		},
		guardaUsuarioEmpresa: function ({ commit, dispatch, getters }, empresa) {

			let onlyUser = (!!!empresa.empresa.nombreComercial || !!getters.getBrand.BornActive);



			return new Promise((resolve, reject) => {
				axios.post('/api/Empresa/guardarUsuarioEmpresa', empresa).then(response => {
					if (response.data.status == 0) {

						if (onlyUser) {
							commit('setError', 504)
						} else {

							if (!!!getters.getBrand.registroEmpresas.mensajepersonalizado) {
								commit('setError', 503)
							} else {
								commit('setErrorCustomMensaje', getters.getBrand.registroEmpresas.mensajepersonalizado);
							}

						}


						resolve(true);
					} else {
						commit('setErrorMensaje', response.data);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		editarUsuario: function ({ commit, dispatch }, usuario) {
			return new Promise((resolve, reject) => {
				axios.get('/api/Empresa/editaUsuario').then(response => {
					(response.data.status == 0) ? resolve(true) : commit('setCompleteError', response);
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		editarEmpresa: function ({ commit, dispatch }, data) {

			return new Promise((resolve, reject) => {
				axios.post('/api/Empresa/editaEmpresaCompletos', data).then(response => {
					if (response.data.status == 0) {
						resolve(true);
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		existeCIF: function ({ commit, dispatch, getters }, cif) {
			return new Promise((resolve, reject) => {
				axios.get(`/api/Empresa/existeCIF/${cif}/Ue5672mK`).then(response => {
					if (response.data.status == 0) {
						(!!response.data.datos) ? resolve(response.data.datos.cif) : resolve(false);
					} else {
						commit('setCompleteError', response);
					}
				})
				.catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		addOferta: function ({ commit, dispatch }, oferta) {
			return new Promise((resolve, reject) => {

				axios.post('/api/Empresa/addOferta', oferta).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						if (!!!oferta.idOferta) {
							if (oferta.contrato == 5) {
								commit('setError', 506);
							}
							else {
								commit('setError', 606);
							}

						} else {
							commit('setError', 512);
						}
					}

					else {
						// console.log(response.data)
						commit('setErrorMensaje', response.data);
						// commit('setErrorMensaje', response.data)
						if (response.data.status == 109) {
							console.log(response.data)
							commit('setErrorMensaje', response.data);
						}
						// else if (response.data.status == 104) {
						// 	console.log(response.data)
						// 	commit('setErrorMensaje', response.data);
						// }
						// else if (response.data.status == 58) {
						// 	commit('setErrorMensaje', response.data);
						// }

						// else {
						// 	commit('setCompleteError', response);
						// 	if (response.data.status == 1) {
						// 		dispatch("sendInfoPeticion", oferta);
						// 	}
						// }
						resolve(false);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		dameProceso: function ({ commit, dispatch }, urlproceso) {
			return new Promise((resolve, reject) => {
				axios.get(`/api/Empresa/dameDatosProceso/${urlproceso}`).then(response => {
					(response.data.status == 0) ? resolve(response.data.datos) : commit('setCompleteError', response);
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		dameProcesocomoCandidato: function ({ commit, dispatch }, urlproceso) {
			return new Promise((resolve, reject) => {
				axios.get(`/api/Empresa/dameDatosProcesoComoAlumno/${urlproceso}`).then(response => {
					(response.data.status == 0) ? resolve(response.data.datos) : commit('setCompleteError', response);
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		dameCandidato: function ({ commit, dispatch }, candidato) {
			return new Promise((resolve, reject) => {
				axios.get(`/api/Empresa/dameCandidato/${candidato}`).then(response => {
					(response.data.status == 0) ? commit('setCV', response.data.datos) : commit('setCompleteError', response);
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		removeCV: function ({ commit, dispatch }) {
			commit('removeCV');
		},
		cambiarEstadoCandidatura: function ({ commit, dispatch }, data) {
			return new Promise((resolve, reject) => {
				axios.post('/api/Empresa/cambiaEstadoCandidatura', data).then(response => {
					(response.data.status == 0) ? resolve(true) : commit('setCompleteError', response);
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestOfertaEditable: function ({ commit, dispatch }, urloferta) {
			return new Promise((resolve, reject) => {
				axios.get(`/api/Empresa/dameOfertaEditable/${urloferta}`).then(response => {
					(response.data.status == 0) ? resolve(response.data.datos) : commit('setCompleteError', response);
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		cerrarOferta: function ({ commit, dispatch }, data) {
			return new Promise((resolve, reject) => {
				axios.post('/api/Empresa/cerrarOferta', data).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setError', 511);
					} else {
						commit('setCompleteError', response);
						resolve(false);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
						resolve(false);
					});
			});
		},
		duplicarOferta({ commit }, oferta) {
			return new Promise((resolve, reject) => {
				axios.post('/api/Empresa/copiarOferta', { "urlOferta": oferta }).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos.urlAcceso);
					} else {
						console.log(response.data)
						commit('setErrorMensaje', response.data);
						// commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		duplicarOfertaContrario({ commit }, oferta) {
			return new Promise((resolve, reject) => {
				axios.post('/api/Empresa/copiarOfertaPerfilContrario', { "urlOferta": oferta }).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos.urlAcceso);
					} else {
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestConvenios({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get('/api/Empresa/dameConveniosEmpresa').then(response => {
					if (response.data.datos.length > 0) {
						resolve(response.data.datos);
					} else {
						reject(false);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		requestDocumentosPracticas({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get('/api/Empresa/dameDocumentosPracticas').then(response => {
					if (response.data.datos.length > 0) {
						resolve(response.data.datos);
					} else {
						reject(false);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		borrarOferta({ commit }, oferta) {
			return new Promise((resolve, reject) => {
				axios.post('/api/Empresa/deleteOferta', { "urlOferta": oferta }).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setError', 516);
					} else {
						reject(false);
						commit('setCompleteError', response);
					}
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		checkFaltanDatosEmpresa({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get('/api/Empresa/faltanDatosAlaEmpresa').then(response => {
					if (response.data.status == 0) {
						commit('setFaltanDatosAlaEmpresa', response.data.datos)
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		checkFaltanDatosContacto({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get('/api/Empresa/faltanDatosAlContactoEmpresa').then(response => {
					if (response.data.status == 0) {
						commit('setFaltanDatosAlContacto', response.data.datos)
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		getDatosContacto({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get('/api/Empresa/dameDatosContactoEmpresa').then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		editDatosContacto({ commit, dispatch }, data) {
			return new Promise((resolve, reject) => {

				axios.post('/api/Empresa/editaContactoEmpresa', data).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						let user = `${data.nombre} ${data.apellidos}`;
						commit('setNombreUsuarioCambiado', user)
					} else {
						resolve(false)
						commit('setCompleteError', response);
						if (response.data.status == 1) {
							dispatch("sendInfoPeticion", data);
						}
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		requestPracticasGestionadas: function ({ commit, dispatch }) {

			return new Promise((resolve, reject) => {
				axios.get(`api/Empresa/damePracticas`).then(response => {
					(response.data.status == 0) ? commit('setPracticasGestionadas', response.data.datos) : commit('setCompleteError', response);
				})
					.catch(function (error) {
						commit('setError', 500);
						dispatch('sendErrorServer', error.response);
					});
			});
		},
		solicitarCambioPractica: function ({ commit, dispatch }, data) {

			return new Promise((resolve, reject) => {
				axios.post(`api/Empresa/solictitarAccionSobrePractica`, data).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setError', 529);
					} else {
						commit('setCompleteError', response);
						resolve(false);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		subirConvenio: function ({ commit, dispatch, getters }, data) {


			return new Promise((resolve, reject) => {
				axios.post(`api/Empresa/adjuntaFicheroAlConvenioEmpresa`, data).then(response => {
					if (response.data.status == 0) {
						resolve(true);


						if (!!getters.getBrand.mensajeconveniosubido) {
							commit('setErrorCustomMensaje', getters.getBrand.mensajeconveniosubido);
						} else {
							commit('setError', 536);
						}

					} else {
						commit('setCompleteError', response);
						resolve(false);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		addContactoEmpresa: function ({ commit, dispatch }, data) {

			return new Promise((resolve, reject) => {
				axios.post(`api/Empresa/addContactoEmpresa`, data).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
						commit('setError', 538);
					} else {
						commit('setCompleteError', response);
						resolve(false);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		addCuentaFiscal: function ({ commit, dispatch }, data) {

			return new Promise((resolve, reject) => {
				axios.post(`api/Empresa/addCuentaFacturacion`, data).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setError', 531);
					} else {
						commit('setCompleteError', response);
						resolve(false);
					}
				});
			});
		},
		checkMenuEducacion({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get('/api/Empresa/tieneMenuSolicitudesPracticasEducacion').then(response => {
					if (response.data.status == 0) {
						commit('setMenuEducacion', response.data.datos)
						if (response.data.datos) {
							dispatch('dameSolicitudesPracticasEducacion');
						}
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		addConvenioEmpresa: function ({ commit, dispatch, getters }, data) {

			return new Promise((resolve, reject) => {
				axios.post(`api/Empresa/addSolicitudConvenioEmpresa`, data).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						if (!!getters.getBrand.mensajeconveniogenerado) {
							commit('setErrorCustomMensaje', getters.getBrand.mensajeconveniogenerado);
						}
					} else {
						commit('setCompleteError', response);
					}
				});
			});
		},
		dameSolicitudesPracticasEducacion({ commit, dispatch }) {
			return new Promise((resolve, reject) => {
				axios.get('/api/Empresa/dameSolicitudesPracticasEducacion').then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
						commit('setSolicitudes', response.data.datos);
					} else {
						resolve(false);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		getFichaEducacion({ commit, dispatch }, id) {
			return new Promise((resolve, reject) => {
				axios.get('/api/Empresa/dameSolicitudPractica/' + id).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		rechazarSolicitudEducacion({ commit, dispatch }, data) {
			return new Promise((resolve, reject) => {
				axios.post('/api/Empresa/rechazarSolicitudPractica/', data).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setError', 530);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		aceptarSolicitudEducacion({ commit, dispatch }, data) {

			return new Promise((resolve, reject) => {
				axios.post('/api/Empresa/aceptarSolicitudPractica/', data).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						commit('setError', 531);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		isIsla({ commit, dispatch }, id) {

			return new Promise((resolve, reject) => {
				axios.get(`/api/dominios/esProvinciaConIslas/${id}`).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		requestEraseCentro({ commit, dispatch }, data) {
			return new Promise((resolve, reject) => {
				axios.post(`/api/Empresa/eliminaCentroDeTrabajo`, data).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
						dispatch('requestDatosEmpresa');
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		requestSaveCentro({ commit, dispatch }, data) {
			return new Promise((resolve, reject) => {
				axios.post(`/api/empresa/editaCentroDeTrabajo`, data).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
						commit('setError', 98);
						// dispatch('requestDatosEmpresa');
					} else {
						commit('setErrorMensaje', response.data);
						resolve(false);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		requestSaveTutorPracticas({ commit, dispatch }, data) {
			return new Promise((resolve, reject) => {
				axios.post(`api/Empresa/addContactoEmpresa_tutorPracticas_PorEmail`, data).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
						commit('setError', 97);
						dispatch('requestTutoresPracticas');
					} else {
						commit('setCompleteError', response);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		requestSaveContactoResponsablePracticas({ commit, dispatch }, data) {
			return new Promise((resolve, reject) => {
				axios.post(`api/Empresa/addContactoEmpresa_contacto_PorEmail`, data).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
						commit('setError', 96);
						dispatch('requestContactosPracticas');
					} else {
						commit('setCompleteError', response);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},
		requestSaveContactoFirmanteAnexo({ commit, dispatch }, data) {
			return new Promise((resolve, reject) => {
				axios.post(`api/Empresa/addContactoEmpresa_firmanteAnexo_PorEmail`, data).then(response => {
					if (response.data.status == 0) {
						resolve(response.data.datos);
						commit('setError', 96);
						dispatch('requestContactosFirmanteAnexo');
					} else {
						commit('setCompleteError', response);
					}
				}).catch(function (error) {
					commit('setError', 500);
					dispatch('sendErrorServer', error.response);
				});
			});
		},



		Unsubscribe: function ({ commit, dispatch, getters }, data) {
			return new Promise((resolve, reject) => {
				axios.post(`api/Empresa/solicitarBajaServicio`, data).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						if (!!getters.getBrand.mensajeBaja) {
							commit('setErrorCustomMensaje', getters.getBrand.mensajeBaja);
						}
					} else {
						commit('setCompleteError', response);
					}
				});
			});
		},
		UnsubscribeAlumno: function ({ commit, dispatch, getters }, data) {
			return new Promise((resolve, reject) => {
				axios.post(`api/alumno/solicitarBajaServicioConDatos`, data).then(response => {
					if (response.data.status == 0) {
						resolve(true);
						if (!!getters.getBrand.mensajeBaja) {
							commit('setErrorCustomMensaje', getters.getBrand.mensajeBaja);
						}
					} else {
						commit('setCompleteError', response);
					}
				});
			});
		},
		requestFirmaConvenioAlert: function ({ commit, dispatch, getters }, data) {

			if (data) {


			}

		},
		requestContactoById({ commit, dispatch }, {
			id = 'default'
		} = {}) {
			return new Promise((resolve, reject) => {
        		axios
        		  .get(`/api/empresa/dameDatosContactoPorId/` + id)
        		  .then(function(result) {
        		    if (result.data.status == 0) {
						commit("completDatosContactoByIdPracticas", {
							data: result.data.datos,
							id: id
						});
						resolve(result.data.datos);
        		    }
				})
				.catch(function (error) {
						dispatch("sendErrorServer", error.response);
				  });
      		});
		},
		requestTutoresPracticas({ commit, dispatch, state }) {
			axios.get(`/api/empresa/dameContactosTipoTutorPracticas`).then(function (result) {
				if (result.data.status == 0) {
					commit('setTutoresPracticas', result.data.datos)
					Object.keys(result.data.datos).forEach(element => {
						dispatch('requestContactoById', {
							id: element
						})
					}),
						resolve(result.data.datos)
				}
			}).catch(function (error) { });
		},
		requestContactosPracticas({ commit, dispatch, state }) {
			axios.get(`/api/empresa/dameContactosTipoContacto`).then(function (result) {
				if (result.data.status == 0) {
					commit('setContactosPracticas', result.data.datos)
					Object.keys(result.data.datos).forEach(element => {
						dispatch('requestContactoById', {
							id: element
						})
					}),
						resolve(result.data.datos)
				}
			}).catch(function (error) { });
		},
		requestContactosFirmanteAnexo({ commit, dispatch, state }) {
			axios.get(`/api/empresa/dameContactosTipoFirmanteAnexo `).then(function (result) {
				if (result.data.status == 0) {
					commit('setContactosFirmanteAnexo', result.data.datos)
					Object.keys(result.data.datos).forEach(element => {
						dispatch('requestContactoById', {
							id: element
						})
					}),
						resolve(result.data.datos)
				}
			}).catch(function (error) { });
		},
		requestContactosFirmanteConvenio({ commit, dispatch }) {
			return axios
				.get(`/api/empresa/dameContactosTipoFirmanteConvenio`)
				.then(result => {
					if (result.data.status == 0) {
						const ids = Object.keys(result.data.datos || {});
						return Promise.all(
							ids.map(id => {
								return axios
									.get(`/api/empresa/dameDatosContactoPorId/` + id)
									.then(res => {
										if (res.data.status == 0) {
											commit('setContactosFirmanteConvenio', {
												data: res.data.datos
											});
											return res.data.datos;
										}
									})
									.catch(error => {
										dispatch('sendErrorServer', error.response);
										throw error;
									});
							})
						);
					}
					return [];
				})
				.catch(error => {
					dispatch('sendErrorServer', error.response);
					throw error;
				});
		},
	},
	mutations: {
		setTutoresPracticas: function (state, data) {
			state.tutoresPracticas = data
			Object.entries(state.tutoresPracticas).forEach(element => {
				let obj = {
					id: element[0],
					nameComplet: element[1]
				}
				state.tutoresPracticas[element[0]] = Object.assign({}, obj)
			})
		},
		setContactosPracticas: function (state, data) {
			state.contactosResponsablesPracticas = data
			Object.entries(state.contactosResponsablesPracticas).forEach(element => {
				let obj = {
					id: element[0],
					nameComplet: element[1]
				}
				state.contactosResponsablesPracticas[element[0]] = Object.assign({}, obj)
			})
		},
		setContactosFirmanteAnexo: function (state, data) {
			state.contactosFirmanteAnexo = data
			Object.entries(state.contactosFirmanteAnexo).forEach(element => {
				let obj = {
					id: element[0],
					nameComplet: element[1]
				}
				state.contactosFirmanteAnexo[element[0]] = Object.assign({}, obj)
			})
		},
		setContactosFirmanteConvenio: function (state, { data }) {
            if (!state.contactosFirmanteConvenio.find(c => c.idContacto === data.idContacto)) {
				state.contactosFirmanteConvenio.push(data);
			}
		},
		completDatosContactoByIdPracticas(state, { data, id }) {
			if (state.tutoresPracticas[id]) {
				state.tutoresPracticas[id] = Object.assign(state.tutoresPracticas[id], data)
			}
			if (state.contactosResponsablesPracticas[id]) {
				state.contactosResponsablesPracticas[id] = Object.assign(state.contactosResponsablesPracticas[id], data)
			}
			if (state.contactosFirmanteAnexo[id]) {
				state.contactosFirmanteAnexo[id] = Object.assign(state.contactosFirmanteAnexo[id], data)
			}
		},

		setCentrosTrabajo: function (state, data) {
			state.centrosTrabajoRegistroBeforeSend.push(data);
		},
		loadingProcesos(state) {
			state.loadingProcesos = true;
		},
		endLoadProcesos(state) {
			state.loadingProcesos = false;
		},
		setProcesos: function (state, data) {
			state.procesos = data;
		},
		setNumProcesos: function (state, data) {
			state.NumTipoProcesos = data;
		},
		setProcesos: function (state, data) {
			state.procesos = data;
		},
		setClikedPopupFaltaConvenio: function (state) {
			state.clickedPopupFaltaConvenio = false;
		},
		editCentroSelected: function (state, { index, data }) {
			return state.centrosTrabajoRegistroBeforeSend[index] = data
		},
		removeCentroSelected: function (state, index) {
			const resultado = state.centrosTrabajoRegistroBeforeSend.filter(centro => centro != state.centrosTrabajoRegistroBeforeSend[index]);
			return state.centrosTrabajoRegistroBeforeSend = resultado
		},
		resetCentroSelected: function (state) {
			return state.centrosTrabajoRegistroBeforeSend = []
		},
		setDatosEmpresa: function (state, data) {
			if (!!data.descripcion) {
				data.descripcion = data.descripcion.replace(new RegExp('<br/>', 'g'), "\r");
			}
			state.datosEmpresa = data;
			if (state.datosEmpresa.centrosTrabajo) {
				let arrObjCentros = {}
				Object.values(state.datosEmpresa.centrosTrabajo).forEach(element => {
					if (arrObjCentros[element.idCentro] == null) {
						arrObjCentros[element.idCentro] = {}
					}
					arrObjCentros[element.idCentro] = element;
				})
				state.datosEmpresa.centrosTrabajo = arrObjCentros

			}
		},
		setDescripcionEmpresa: function (state, data) {
			state.datosEmpresa.descripcion = data;
		},
		setAnexosPracticas: function (state, data) {
			state.anexosPracticas = data;
		},
		setFaltanDatosAlaEmpresa(state, status) {
			state.faltaDatosAlaEmpresa = status;
		},
		setFaltanDatosAlContacto(state, status) {
			state.faltaDatosAlContacto = status;
		},
		setPracticasGestionadas(state, status) {
			state.practicasGestionadas = status;
		},
		setMenuEducacion(state, status) {
			state.menuEducacion = status;
		},
		setSolicitudes(state, status) {
			state.solicitudesEducacion = status;
		}


	}
}

export default accionesEmpresas;



// WEBPACK FOOTER //
// ./src/store/accionesEmpresa.js